<div class="grid">
  <div class="col-12">
    <div class="main-title">Configuración</div>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Nombre completo:</h4>
    <p>{{ data.client.name }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Tipo de persona:</h4>
    <p>{{ data.client.entity }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">RFC:</h4>
    <p>{{ data.client.rfc }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">CURP:</h4>
    <p>{{ data.client.curp }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Nacionalidad:</h4>
    <p>{{ data.client.nationality }}</p>
  </div>
  <div class="col-12">
    <div class="main-title">Domicilio operativo</div>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Pais:</h4>
    <p>{{ data?.client?.address?.country }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Estado:</h4>
    <p>{{ data?.client?.address?.state }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Municipio:</h4>
    <p>{{ data?.client?.address?.municipality }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Colonia:</h4>
    <p>{{ data?.client?.address?.colony }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Ciudad:</h4>
    <p>{{ data?.client?.address?.city }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">CP:</h4>
    <p>{{ data?.client?.address?.postalCode }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Calle:</h4>
    <p>{{ data?.client?.address?.street }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Número interior:</h4>
    <p>{{ data?.client?.address?.interiorNumber }}</p>
  </div>
  <div class="col-12 md:col-6 xl:col-4">
    <h4 class="mb-2">Número exterior:</h4>
    <p>{{ data?.client?.address?.exteriorNumber }}</p>
  </div>
  <div class="col-12 md:col-6">
    <h4 class="mb-2">¿El domicilio operativo es el mismo al fiscal?</h4>
    <p>{{ data.client.sameLegalAddress ? 'Sí' : 'No' }}</p>
  </div>
  <div *ngIf="!data.client.sameLegalAddress" class="col-12">
    <div class="main-title">Domicilio fiscal</div>
    <div class="grid">
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">País:</h4>
        <p>{{ data?.client?.legalAddress?.country }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Estado:</h4>
        <p>{{ data?.client?.legalAddress?.state }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Municipio:</h4>
        <p>{{ data?.client?.legalAddress?.municipality }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Colonia:</h4>
        <p>{{ data?.client?.legalAddress?.colony }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Ciudad:</h4>
        <p>{{ data?.client?.legalAddress?.city }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">CP:</h4>
        <p>{{ data?.client?.legalAddress?.postalCode }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Calle:</h4>
        <p>{{ data?.client?.legalAddress?.street }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Número interior:</h4>
        <p>{{ data?.client?.legalAddress?.interiorNumber }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Número exterior:</h4>
        <p>{{ data?.client?.legalAddress?.exteriorNumber }}</p>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="main-title">Datos de contacto</div>
  </div>
  <div class="col-12 md:col-4">
    <h4 class="mb-2">Tipo de contacto:</h4>
    <p>Personal</p>
  </div>
  <div class="col-12 md:col-4">
    <h4 class="mb-2">Teléfono:</h4>
    <p>{{ data.client.phone }}</p>
  </div>
  <div class="col-12 md:col-4">
    <h4 class="mb-2">Email:</h4>
    <p>{{ data.client.email }}</p>
  </div>
  <div *ngFor="let contact of otherContacts" class="col-12">
    <div class="grid">
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Tipo de contacto:</h4>
        <p>{{ contact.contactType }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Nombre:</h4>
        <p>{{ contact.firstName }} {{ contact.lastName }} {{ contact.middleName }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Teléfono:</h4>
        <p>{{ contact.phone }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Email:</h4>
        <p>{{ contact.email }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">RFC:</h4>
        <p>{{ contact.rfc }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">CURP:</h4>
        <p>{{ contact.curp }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Puesto:</h4>
        <p>{{ contact.position }}</p>
      </div>
      <div class="col-12 md:col-6 xl:col-4">
        <h4 class="mb-2">Porcentaje de participación:</h4>
        <p>{{ contact.participationPercentage }}%</p>
      </div>
    </div>
  </div>
  <ng-container *ngIf="guarantors.length > 0">
    <div class="col-12">
      <div class="main-title">Obligados solidarios</div>
    </div>
    <div *ngFor="let guarantor of guarantors; let first = first" class="col-12">
      <div class="grid">
        <div class="col-12" *ngIf="!first">
          <hr />
        </div>
        <div class="col-12 md:col-6 xl:col-4">
          <h4 class="mb-2">Nombre o razón social:</h4>
          <p>{{ guarantorName(guarantor) }}</p>
        </div>
        <div class="col-12 md:col-6 xl:col-4">
          <h4 class="mb-2">Tipo de persona:</h4>
          <p>{{ guarantor.personType === 'PM' ? 'Persona moral' : 'Persona física' }}</p>
        </div>
        <div class="col-12 md:col-6 xl:col-4">
          <h4 class="mb-2">Relación con el cliente:</h4>
          <p>{{ guarantorRelationship(guarantor.relationship) }}</p>
        </div>
        <div class="col-12 md:col-6 xl:col-4" *ngIf="guarantor.rfc">
          <h4 class="mb-2">RFC:</h4>
          <p>{{ guarantor.rfc }}</p>
        </div>
        <div class="col-12 md:col-6 xl:col-4" *ngIf="guarantor.curp">
          <h4 class="mb-2">CURP:</h4>
          <p>{{ guarantor.curp }}</p>
        </div>
        <div class="col-12 md:col-6 xl:col-4">
          <h4 class="mb-2">Celular:</h4>
          <p>{{ guarantor.phone }}</p>
        </div>
        <div class="col-12 md:col-6 xl:col-4" *ngIf="guarantor.email">
          <h4 class="mb-2">Email:</h4>
          <p>{{ guarantor.email }}</p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
